import React, { PureComponent } from 'react';
import ArticleList from './article/article.list.component';
import { Helmet } from 'react-helmet';
import Hidden from '@material-ui/core/Hidden';
import Header from 'component/_structure/site/header/header.component';
import { userLogin } from 'store/action/user.action';
import ResponsiveDrawer from 'component/_structure/site/header/header.mobile.component';
import { connect } from 'react-redux';
import { resetPassword } from 'store/action/email.action';

class Home extends PureComponent {
  render() {
    const { userLogin, user, isAdmin } = this.props;
    return (
      <>
        <Helmet>
          <title>Juslabore</title>
          <meta
            name="description"
            content="Plataforma Juslabore, com intuito de ajudar e instruir advogados, com notícias e ferramentas."
          />
        </Helmet>

        <Hidden smDown>
          <Header
            isUserLoggedIn={user !== null}
            user={user}
            userLogin={userLogin}
            isAdmin={isAdmin}
          />
        </Hidden>

        <ResponsiveDrawer
          isUserLoggedIn={user !== null}
          user={user}
          userLogin={userLogin}
          isAdmin={isAdmin}
        />
        <ArticleList />
      </>
    );
  }
}

function mapStateToProps({ user }) {
  return {
    user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: user => dispatch(userLogin(user)),
    resetPassword: email => dispatch(resetPassword(email)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Home);
